const s={light:"radio--light"};export{s as colors};
//# sourceMappingURL=radio.types.js.map
